import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext, useAnalytics } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import RequireCustomer from '../layouts/my-account/require-customer';
import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';

const AppLayout = lazy(() => import('~/apps/account-linking/AppLayout'));

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { track } = useAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.ACCOUNT_LINKING);

  useOnLoad(() => {
    const title = t('ACCOUNT_LINKING_PAGE_TITLE', { defaultValue: 'Integrations' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.ACCOUNT_LINKING });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.AccountLinking, showSmartActions: true }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.AccountLinking
      }
    });
  });

  return (
    <Tagged tag="screen-integrations">
      <RequireCustomer isXs={isXs} silent={true}>
        <Suspense>
          <AppLayout />
        </Suspense>
      </RequireCustomer>
    </Tagged>
  );
}

Component.displayName = 'eCommerce Accounts';
